import s from './custom-tabs-extra-content.module.scss';

export const CustomTabsExtraContent = () => (
	<div className={s.intro}>
		🚀 <span>Choose how to download analytics to start your new project</span>
	</div>
);
